<div style="margin-left:10px;margin-right:10px" class="component">
  <h3>Line-Item List</h3>
  <div *ngIf="reloading" style="align-content:center">
    <span style="align-content:center;"><mat-spinner [diameter]="30"></mat-spinner> File being processed</span>
  </div>

  <div class="buttonGroup" style="float:right;margin-top:10px">
    <button (click)="showUploadFileDialog()" mat-raised-button color="primary">Upload File</button>
    <span style='color:red;margin-right:1.25em; display:inline-block;'>&nbsp;</span>
    <button (click)="loadData()" mat-raised-button color="primary" class="first-button">Refresh</button>
    <span style='color:red;margin-right:1.25em; display:inline-block;'>&nbsp;</span>
    <a download href="assets/Template.xlsx" mat-raised-button color="primary" class="first-button">Download Template</a>
    <span style='color:red;margin-right:1.25em; display:inline-block;'>&nbsp;</span>
  </div>
  <div class="alignleft content mat-elevation-z8">
    <mat-form-field style=" margin: 10px; width: 50%;">
      <input matInput (keyup)="ApplyFilter($event.target.value)" placeholder="Type keyword to filter results" id="input_filter">
    </mat-form-field>
  </div>
  <div class="table-container-scroll">
  <table style="width:100%;" mat-table [dataSource]="LineItemListData" matSort matSortActive="lineItemListID" matSortDisableClear matSortDirection="desc">
    <!-- Columns -->
    <ng-container matColumnDef="batchProcessDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear=>{{getColumnHeaderName('batchProcessDate')}} </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.batchProcessDate.toLocaleString() | highlight: LineItemListData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="batchUploadDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getColumnHeaderName('batchUploadDate')}} </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.batchUploadDate.toLocaleString() | highlight: LineItemListData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getColumnHeaderName('fileName')}} </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.fileName | highlight: LineItemListData.filter"></td>
    </ng-container>

    <ng-container matColumnDef="lineItemListID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getColumnHeaderName('lineItemListID')}} </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.lineItemListID | highlight: LineItemListData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="noOfRecords">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getColumnHeaderName('noOfRecords')}} </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.noOfRecords | highlight: LineItemListData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="statusDesc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getColumnHeaderName('statusDesc')}} </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.statusDesc | highlight: LineItemListData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="userID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getColumnHeaderName('userID')}}</th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.userID | highlight: LineItemListData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="downloadButton">
      <th mat-header-cell *matHeaderCellDef>{{getColumnHeaderName('downloadButton')}}</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="showDownloadButton(row.statusDesc)">
          @if (externalUser) {
            <button mat-raised-button
                    (click)="downloadFile(row.userID,row.fileName,row.lineItemListID,'external')"
                    color="primary">
              Export</button>
          } @else {
            <button mat-raised-button
                    [matMenuTriggerFor]="menu"
                    color="primary">
              Export</button>
          }
        </ng-container>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="downloadFile(row.userID,row.fileName,row.lineItemListID,'internal')" color="primary">Internal Only</button>
          <button mat-menu-item (click)="downloadFile(row.userID,row.fileName,row.lineItemListID,'membersafe')" color="primary">Member Safe</button>
        </mat-menu>
      </td>
    </ng-container>
    <ng-container matColumnDef="errorDesc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getColumnHeaderName('errorDesc')}} </th>
      <td mat-cell *matCellDef="let row" class="centered">
        <button *ngIf="showIndividualErrorButton(row.individualLineItemErrors)" (click)="downloadIndividualErrors(row.lineItemListID)" mat-raised-button color="primary">Errors</button>
        <span *ngIf="!showIndividualErrorButton(row.individualLineItemErrors)" [innerHTML]="row.errorDesc | highlight: LineItemListData.filter"></span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>
  <div style="width:100%; text-align:center; background-color:white; padding-top:10px; padding-bottom:10px;"
       *ngIf="LineItemListData.data.length === 0">
    <span *ngIf="!Loading && NoData && !Error">No records found</span>
    <span style="align-content:center;" *ngIf="Loading"><mat-spinner [diameter]="30"></mat-spinner> Loading...</span>
    <span style="align-content:center;" *ngIf="Error">An Error happened during the data load.  If this continues contact support.</span>
  </div>
  <mat-paginator (page)="changePageSize($event.pageSize)" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]=pagLILPageSize showFirstLastButtons></mat-paginator>
</div>
